'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _ScrollPercentageTrigger = require('./ScrollPercentageTrigger');

var _ScrollPercentageTrigger2 = _interopRequireDefault(_ScrollPercentageTrigger);

var _TimeDelayTrigger = require('./TimeDelayTrigger');

var _TimeDelayTrigger2 = _interopRequireDefault(_TimeDelayTrigger);

var _ExitIntentTrigger = require('./ExitIntentTrigger');

var _ExitIntentTrigger2 = _interopRequireDefault(_ExitIntentTrigger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ClientTriggers = new _immutable.Record({
  displayOnScrollPercentage: new _ScrollPercentageTrigger2.default(),
  displayOnTimeDelay: new _TimeDelayTrigger2.default(),
  displayOnExitIntent: new _ExitIntentTrigger2.default()
}, 'ClientTriggers');

exports.default = ClientTriggers;
module.exports = exports['default'];